export default __webpack_public_path__ + "static/media/AX8qovnIWoYzRtKKtb37Md6Rn5E3.a145feb1.jpg";